import TransitionLine from '../../assets/images/transition/transitionLine.svg?raw';
import TransitionBackground from '../../assets/images/transition/transitionBackground.svg?raw';
import {
  ImageBackground,
  ImageContainer,
  ImageLine,
  MainContainer,
  TransitionText,
} from './TransitionStyledComponent';
import { ROUTES_PATH } from '../../constants';
import { TransitionStepsText } from '../../interfaces/TransitionSteps';

export const Transition = () => {
  const routePath = window.location.pathname;

  const TranstionText = () => {
    let text = '';
    switch (routePath) {
      case ROUTES_PATH.ENTRY:
        text = TransitionStepsText.ENTRY;
        break;
      case ROUTES_PATH.PERSONAL_DATA:
        text = TransitionStepsText.PERSONAL_DATA;
        break;
      case ROUTES_PATH.LABOR_DATA:
        text = TransitionStepsText.DE_DEC; // Antes de la nueva pantalla de contraoferta
        break;
      case ROUTES_PATH.COUNTER_OFFER:
        text = TransitionStepsText.COUNTER_OFFER;
        break;
      case ROUTES_PATH.OCR:
        text = TransitionStepsText.OCR;
        break;
      default:
        text = 'Unos segundos y casi estamos';
    }
    return text;
  };

  return (
    <>
      <MainContainer>
        <TransitionText $fontSize={16}>{TranstionText()}</TransitionText>
        <ImageContainer>
          <ImageLine dangerouslySetInnerHTML={{ __html: TransitionLine }} />
          <ImageBackground
            dangerouslySetInnerHTML={{ __html: TransitionBackground }}
          />
        </ImageContainer>
      </MainContainer>
    </>
  );
};
